module.exports = __webpack_public_path__ + "static/img/service.fcd8ecfe.gif";